import { UploadOutlined } from '@ant-design/icons'
import { Button, Form, Modal, Upload } from 'antd'
import React, { useCallback, useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'

//types
import { UploadFile } from 'antd/lib/upload/interface'
import { ValidateErrorEntity } from 'rc-field-form/lib/interface'
import { AttachmentServiceResponse } from 'types'

export type VideoFormFields = {
  thumbnail: UploadFile<AttachmentServiceResponse>[]
  videoFile: UploadFile<AttachmentServiceResponse>[]
}

const { useForm } = Form

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const normFile = (e: any) => {
  if (Array.isArray(e)) {
    return e
  }
  return e && e.fileList
}

type MediaFormat = 'image' | 'video'

const getDataForUpload = (mediaFormat: MediaFormat) => {
  const ref_content_code = `article_upload_${uuidv4()}`
  const media_type = mediaFormat.toUpperCase()
  const video_source = mediaFormat === 'video' ? 'INTERNAL_CUSTOM' : undefined
  return {
    ref_content_code,
    media_type,
    video_source,
  }
}

interface Props {
  showModal: boolean
  uploadUrl: string
  onSubmit: (values: VideoFormFields) => void
  onClose: () => void
}
export const VideoMarkdownPopup: React.FC<Props> = ({
  showModal,
  uploadUrl,
  onSubmit,
  onClose,
}) => {
  const [videoForm] = useForm<VideoFormFields>()

  useEffect(() => {
    if (!showModal) {
      videoForm.resetFields()
    }
  }, [showModal])

  const onModalCancel = useCallback(() => {
    onClose()
  }, [])

  const handleVideoFormSubmit = (values: VideoFormFields) => {
    onSubmit(values)
  }

  const handleVideoFormFailed = (
    errorInfo: ValidateErrorEntity<VideoFormFields>,
  ) => {
    console.log({ errorInfo })
  }

  return (
    <Modal
      title='Insert Video Link'
      visible={showModal}
      onCancel={onModalCancel}
      footer={null}
    >
      <Form
        form={videoForm}
        onFinish={handleVideoFormSubmit}
        onFinishFailed={handleVideoFormFailed}
      >
        <Form.Item
          label='Video Thumbnail'
          name='thumbnail'
          valuePropName='fileList'
          getValueFromEvent={normFile}
          rules={[{ required: true, message: 'Please upload a image file!' }]}
        >
          <Upload
            action={uploadUrl}
            accept={'image/*'}
            data={() => getDataForUpload('image')}
            name='input_file'
            listType='picture'
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>
        <Form.Item
          label='Video File'
          name='videoFile'
          valuePropName='fileList'
          getValueFromEvent={normFile}
          rules={[{ required: true, message: 'Please upload a image file!' }]}
        >
          <Upload
            action={uploadUrl}
            accept={'video/*'}
            data={() => getDataForUpload('video')}
            name='input_file'
            listType='picture'
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
          <Button type='primary' htmlType='submit'>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}
